import { isValid, format } from "date-fns";
import config from "@/config.js";

import Search from "@/components/Search.vue";
import Avatar from "@/components/Avatar.vue";
import { sortByDate } from "../../helpers/sorting";

export default {
  name: "home",
  components: {
    Search,
    Avatar
  },
  data() {
    return {
      loading: false,
      statistics: null,
      headers: [
        {
          text: "Player",
          value: "username"
        },
        { text: "Banned by", value: "who_executed" },
        { text: "Ban reason", value: "reason" },
        {
          text: "Date issued",
          value: "time",
          sort: sortByDate
        },
        {
          text: "Expires",
          value: "expiration",
          sort: sortByDate
        }
      ],
      recent_bans: [],
      networkName: config.networkName
    };
  },
  methods: {
    getFormattedDate(date) {
      if (date < 1) return "Never";
      if (!isValid(new Date(date))) return "Unknown";
      return format(new Date(date), "PPp");
    },

    // make numbers pretty, ex: 49036 --> 49,036
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    getRecentBans() {
      this.loading = true;
      fetch(`${config.apiUrl}/${config.networkName}/recent-bans`)
        .then(response => {
          if (response.status !== 200) {
            console.error(response.status);
            return;
          }

          response.json().then(data => {
            this.recent_bans = data;
          });
        })
        .catch(err => console.error(err))
        .finally(() => (this.loading = false));
    },

    getStatistics() {
      fetch(`${config.apiUrl}/${config.networkName}/statistics`)
        .then(response => {
          if (response.status !== 200) {
            console.error(response);
            return;
          }

          response.json().then(data => {
            this.statistics = data;
          });
        })
        .catch(err => console.error(err));
    }
  },
  created() {
    this.getRecentBans();
    this.getStatistics();
  }
};
